import React, { useEffect, useState } from "react";
import { format, parse } from "date-fns";
import { setCommonFilters } from "../../WorkbookSlice";
import { useDispatch } from "react-redux";
import { FaXmark } from "react-icons/fa6";
import { handleFilterInDashboard } from "../../../smallFunction/SmallFunctions";

export default function Aside3DateRangeComp({
  updateDateFilterItem,
  filterItem,
  isFilterVisibleInDashboard,
  dashboardSheetID: dashIDs,
  dashboardType
}) {
  const dispatch = useDispatch();
  // Function to convert "dd/MM/yyyy" to "yyyy-MM-dd"
  const convertToInputDateFormat = (dateStr) => {
    if (!dateStr) return "";
    try {
      const parsedDate = parse(dateStr, "dd/MM/yyyy", new Date());
      return format(parsedDate, "yyyy-MM-dd"); // Correct "MM" instead of "mm"
    } catch (error) {
      console.error("Invalid date format:", dateStr);
      return "";
    }
  };

  // Convert `filterItem.minValue` and `filterItem.maxValue` safely
  const convertedStartDate = convertToInputDateFormat(filterItem.minValue);
  const convertedEndDate = convertToInputDateFormat(filterItem.maxValue);

  const [startDate, setStartDate] = useState(convertedStartDate || "");
  // console.log(startDate);
  const [endDate, setEndDate] = useState(convertedEndDate || "");
  // console.log(endDate);

  useEffect(() => {
    if (
      filterItem?.minValue !== startDate ||
      filterItem?.maxValue !== endDate
    ) {
      const updatedFilterItem = {
        ...filterItem,
        minValue: format(
          parse(startDate, "yyyy-MM-dd", new Date()),
          "dd/MM/yyyy"
        ),
        maxValue: format(
          parse(endDate, "yyyy-MM-dd", new Date()),
          "dd/MM/yyyy"
        ),
      };
      // console.log(updatedFilterItem);
      updateDateFilterItem(filterItem.dataType, updatedFilterItem);
    }
  }, [startDate, endDate]);

  return (
    <div className="px-2 py-1 flex flex-col w-full items-start justify-center gap-1">
      <h1 className="w-full text-left font-light flex items-center justify-between">
        {filterItem.rename}{" "}
        {dashboardType === "makeDashboard" && isFilterVisibleInDashboard ? (
          <FaXmark
            className="font-light text-gray-600 cursor-pointer text-transparent hover:text-black"
            onClick={() =>
              handleFilterInDashboard({
                item: filterItem,
                dashIDs,
                dispatch,
                setCommonFilters,
              })
            }
          />
        ) : null}
      </h1>
      <div className="flex flex-col w-full gap-2 text-xs">
        <div className="flex gap-1 w-full justify-between items-center">
          <label className="font-light w-[25%]">From</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="border rounded p-[2px] w-[73%] cursor-pointer focus:outline-none font-light"
          />
        </div>
        <div className="flex gap-1 w-full justify-between items-center">
          <label className="font-light w-[25%]">To</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="border rounded p-[2px] w-[73%] cursor-pointer focus:outline-none font-light"
          />
        </div>
      </div>
    </div>
  );
}
